import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Another approver may decide something while this tab sits in the background or the user is on
 * another console screen: reload when the window regains focus and when the route is re-entered
 * (the first render has already loaded).
 */
export function useReloadWhenStale(reload: () => void) {
  useEffect(() => {
    window.addEventListener('focus', reload);
    return () => window.removeEventListener('focus', reload);
  }, [reload]);

  const location = useLocation();
  const firstLocation = useRef(true);
  useEffect(() => {
    if (firstLocation.current) {
      firstLocation.current = false;
      return;
    }
    reload();
  }, [location.key, reload]);
}
